export interface Faq {
  question: string
  answer: string
}

export const faqs: Faq[] = [
  {
    question: 'Who is this system for?',
    answer:
      'Welding inspectors, QC technicians, fabrication supervisors, NDT professionals, welding inspection students, and industrial professionals who want organized visual inspection references.',
  },
  {
    question: 'What welding inspection subjects does it cover?',
    answer:
      'The system covers weld joint configurations, welding processes, discontinuity identification, visual testing, dimensional measurement, NDT methods, quality evaluation, and inspection documentation.',
  },
  {
    question: 'Does it include visual weld defect identification?',
    answer:
      'Yes. The atlas includes annotated discontinuity illustrations, weld cross-section diagrams, identification comparisons, and technical references for common welding indications.',
  },
  {
    question: 'Does it include ready-to-use inspection resources?',
    answer:
      'Yes. Field checklists, discontinuity reference cards, measurement records, inspection report templates, NCR forms, and practical inspection scenarios are included.',
  },
  {
    question: 'Is this suitable for beginners?',
    answer:
      'Yes, for learners developing welding inspection knowledge, although the system uses professional terminology and technical concepts. It also provides organized references for experienced professionals.',
  },
  {
    question: 'Does it cover visual inspection and NDT methods?',
    answer:
      'Yes. It includes visual testing procedures and educational references for UT, RT, MT, PT, PAUT, and other relevant examination concepts.',
  },
  {
    question: 'Is this a physical product?',
    answer:
      'No. WELDING INSPECTION VISUAL ATLAS™ is a 100% digital professional educational reference system.',
  },
  {
    question: 'Is this an official welding inspection certification?',
    answer:
      'No. It is an independent technical reference resource. It does not provide AWS, ASME, ISO, CSWIP, or other professional certification, qualification, or regulatory approval.',
  },
  {
    question: 'Does it replace official welding codes or qualified inspectors?',
    answer:
      'No. Actual inspection and acceptance decisions require applicable codes, approved procedures, qualified personnel, and authorized technical evaluation. The atlas is intended for educational and professional reference.',
  },
  {
    question: 'How will I receive it?',
    answer: "You'll receive immediate digital access after purchase.",
  },
]
